import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Layout } from 'antd';
import Sidebar from './Sidebar';
import Header from './Header';
import ProtectedRoute from './ProtectedRoute';
import Dashboard from '../pages/Dashboard';
import Websites from '../pages/Websites';
import WebsiteForm from '../pages/WebsiteForm';
import WebsiteDetail from '../pages/WebsiteDetail';
import WebsiteBuilder from '../pages/WebsiteBuilder';
import Videos from '../pages/Videos';
import VideoForm from '../pages/VideoForm';
import VideoDetail from '../pages/VideoDetail';
import Whitelist from '../pages/Whitelist';
import Settings from '../pages/Settings';
import SpamLinks from '../pages/SpamLinks';
import SpamLinkDetail from '../pages/SpamLinkDetail';
import WebhookStatus from '../pages/WebhookStatus';
import ServerManagement from '../pages/ServerManagement';
import MultiServerStatistics from '../pages/MultiServerStatistics';
import GaTraffic from '../pages/GaTraffic';
import IpWhitelistGuard from './IpWhitelistGuard';

const { Content } = Layout;

const ProtectedRoutes: React.FC = () => {
  return (
    <IpWhitelistGuard>
      <Layout style={{ minHeight: '100vh' }}>
        <Sidebar />
        <Layout>
          <Header />
          <Content style={{ margin: '24px 16px', padding: 24, background: 'var(--bg-primary)', minHeight: 280 }}>
            <Routes>
              <Route path="/" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
              <Route path="/websites" element={<ProtectedRoute><Websites /></ProtectedRoute>} />
              <Route path="/websites/new" element={<ProtectedRoute><WebsiteForm /></ProtectedRoute>} />
              <Route path="/websites/:id" element={<ProtectedRoute><WebsiteDetail /></ProtectedRoute>} />
              <Route path="/websites/:id/edit" element={<ProtectedRoute><WebsiteForm /></ProtectedRoute>} />
              <Route path="/websites/:id/builder" element={<ProtectedRoute><WebsiteBuilder /></ProtectedRoute>} />
              <Route path="/videos" element={<ProtectedRoute><Videos /></ProtectedRoute>} />
              <Route path="/videos/new" element={<ProtectedRoute><VideoForm /></ProtectedRoute>} />
              <Route path="/videos/:id" element={<ProtectedRoute><VideoDetail /></ProtectedRoute>} />
              <Route path="/videos/:id/edit" element={<ProtectedRoute><VideoForm /></ProtectedRoute>} />
              <Route path="/whitelist" element={<ProtectedRoute><Whitelist /></ProtectedRoute>} />
              <Route path="/spam-links" element={<ProtectedRoute><SpamLinks /></ProtectedRoute>} />
              <Route path="/spam-links/:id" element={<ProtectedRoute><SpamLinkDetail /></ProtectedRoute>} />
              <Route path="/webhook-status" element={<ProtectedRoute><WebhookStatus /></ProtectedRoute>} />
              <Route path="/server-management" element={<ProtectedRoute><ServerManagement /></ProtectedRoute>} />
              <Route path="/multi-server-statistics" element={<ProtectedRoute><MultiServerStatistics /></ProtectedRoute>} />
              <Route path="/ga-traffic" element={<ProtectedRoute><GaTraffic /></ProtectedRoute>} />
              <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
              <Route path="/login" element={<Navigate to="/" replace />} />
            </Routes>
          </Content>
        </Layout>
      </Layout>
    </IpWhitelistGuard>
  );
};

export default ProtectedRoutes;
